import React from 'react';
import { AppThunk } from 'store/store';
import { NotificationId } from 'features/notifications/types';
import { JOIN_NOTIFICATION_CONTAINER_ID } from 'features/notifications/constants';
import { notification, NotificationOptions } from 'features/notifications/toast/notification';
import { selectIsSystemSession } from 'features/application/selectors';
import { makeId } from 'features/notifications/makeId';
import JoinNotificationTemplate from 'features/notifications/join-screen-notifications/JoinNotificationTemplate';
import { selectGlobalUser } from 'features/users/usersSlice';
import { EventUser } from 'services/signaling';

// @TODO bring logic from addActionNotification if we need Redux control
export const addJoinNotification =
  (
    props: {
      initiator?: EventUser;
      content?: React.ReactNode;
      scope?: string[];
      initiatorId?: string;
    },
    options?: Omit<NotificationOptions, 'containerId'>
  ): AppThunk<void | NotificationId> =>
  (dispatch, getState) => {
    const isSystemSession = selectIsSystemSession(getState());
    if (isSystemSession) {
      return undefined;
    }

    const notificationId = makeId(options?.toastId);
    const initiator = selectGlobalUser(getState(), props.initiatorId || '') || props.initiator;

    notification(
      ({ data, ...toastContentProps }) => (
        <JoinNotificationTemplate
          {...toastContentProps}
          initiator={initiator}
          {...props}
          id={notificationId}
        />
      ),
      {
        ...options,
        toastId: notificationId,
        containerId: JOIN_NOTIFICATION_CONTAINER_ID,
      }
    );

    return notificationId;
  };
